module.exports = __webpack_public_path__ + "static/mo45-85b0d90bb23e194dbd2d670034665645.png";